<template>
	<v-container>
		<v-row v-if="notifications.length" dense class="mb-2">
			<v-col cols="12" class="d-flex justify-end">
				<v-btn small text color="primary" @click="markAllAsRead">
					{{$T('mark-all-as-read')}}
				</v-btn>
			</v-col>
		</v-row>

		<v-row dense>
			<v-col
				v-for="notification in notifications"
				:key="notification.id"
				lg="3"
				md="4"
				sm="6"
				cols="12"
			>
				<v-list-item
					class="elevation-2 rounded"
					@click="openNotification(notification)"
				>
					<v-list-item-avatar class="me-3">
						<v-avatar size="38" color="primary lighten-5">
							<v-icon color="primary">mdi-bell</v-icon>
						</v-avatar>
					</v-list-item-avatar>
					<v-list-item-content>
						<v-list-item-title class="text-body-2 font-weight-medium text-wrap">
							{{notification.title}}
						</v-list-item-title>
						<v-list-item-subtitle class="text-caption grey--text text-wrap">
							{{notification.body}}
						</v-list-item-subtitle>
						<v-list-item-subtitle class="text-caption grey--text">
							{{moment(notification.createdAt).format('YYYY-MM-DD HH:mm')}}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-col>
		</v-row>

		<div
			v-if="!notifications.length"
			class="d-flex flex-column justify-center align-center"
			style="height: 65vh"
		>
			<v-icon x-large class="mb-3">mdi-bell-ring</v-icon>
			<span class="grey--text text--darken-2">{{$T('no-notifications')}}</span>
		</div>
	</v-container>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex'
export default {
	name: 'Notifications',

	computed: {
		...mapState({
			notifications: state => state.notifications.notifications
		})
	},

	methods: {
		fetchNotifications() {
			this.$store.dispatch('notifications/fetchNotifications');
			this.$store.dispatch('notifications/fetchUnreadCount');
		},

		openNotification(notification) {
			this.$store.dispatch('notifications/markNotificationAsRead', {
				notificationId: notification.id
			}).then(() => {
				this.fetchNotifications();
			});
			if (notification.redirectUrl) {
				this.$router.push(notification.redirectUrl).catch(() => {});
			}
		},

		markAllAsRead() {
			this.$store.dispatch('notifications/markAllAsRead').then(() => {
				this.fetchNotifications();
			});
		},

		moment
	},

	created() {
		this.fetchNotifications();
	}
}
</script>

<style>

</style>
